module.exports = __webpack_public_path__ + "static/media/switch_off.c3e2dfcb.png";